import { GamesByTechnique } from "shared/games/allTechniqueGameDescriptions";
import { GameRound } from "shared/games/types/GameRound";
import Shape, { Props as ShapeProps } from "ui/atoms/Shape/Shape";
import useOnChangeHandler from "./useOnChangeHandler";

export default function TechniqueShape({
  changers,
  technique,
  value,
  theme = "default",
}: {
  changers: ReturnType<typeof useOnChangeHandler>;
  technique: GamesByTechnique;
  value: GameRound;
  theme?: ShapeProps["theme"];
}) {
  return (
    <Shape
      onClick={() => changers.onTechniqueToggle(technique.technique)}
      shape="circle"
      type="icon"
      text={technique.name}
      theme={theme}
      icon={technique.icon}
      outline="thick"
      active={value.techniques.includes(technique.technique)}
    />
  );
}
